import {withProps} from 'recompose';

export default withProps(({currentUser}) => ({
    supervisorList: currentUser.SupervisorList || []
})); 